<sc-draggable-row-container>
  <sc-padding>
    <sc-flex [gap]="16">
      <sc-flex-fitting-content>
        @if (showDetails) {
        <sc-formular-component [model]="rule"
          [context]="{layout: detailLayout!, detailLayoutItemProvider: detailLayoutItemProvider!}"></sc-formular-component>
        <sc-content-spacer vertical></sc-content-spacer>
        <cext-conditions-view [condition]="condition" [readOnly]="true"></cext-conditions-view>
        }
        @if (!showDetails) {
        {{rule?.name}}
        }
      </sc-flex-fitting-content>
      <sc-flex centered [vertical]="showDetails">
        <sc-edit-action-button large (click)="editRule.emit(rule)"></sc-edit-action-button>
        <sc-content-spacer vertical></sc-content-spacer>
        <sc-delete-action-button large (click)="deleteRule.emit(rule)"></sc-delete-action-button>
      </sc-flex>
    </sc-flex>
  </sc-padding>
</sc-draggable-row-container>
